///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { FormattedMessage } from "react-intl";

import RxoLogoIcon from "../../icons/RXOLogoIcon";
import messages from "../../../helpers/messages";

function SystemMessage(props) {
  const isRejectedMessage =
    typeof props.action === "string" &&
    props.action.startsWith("Bid was rejected");
  const messageFormat = isRejectedMessage
    ? messages.systemMessageRejectedFormat
    : messages.systemMessageFormat;

  return (
    <div
      className="m-auto border-bottom-grey pt-8 pb-8 mx-16 flex"
      data-testid={props["data-testid"]}
    >
      <RxoLogoIcon
        height="36px"
        width="36px"
        className="grid__cell inline-block"
      />
      <div className="grid__cell t90 pl-12 flex items-center system-message">
        <p className="mb-0 pos-relative one-whole pr-20">
          <FormattedMessage
            {...messageFormat}
            values={{
              action: props.action,
              userName: props.userName,
              date: props.date
            }}
          />
          {!props.isPreviouslySeenByUser && (
            <span className="unread-message round inline-block mb-0 mr-4">
              &nbsp;
            </span>
          )}
        </p>
      </div>
    </div>
  );
}

export default SystemMessage;
